export const department = {
    hssShort: "HSS",
    aeShort: "AE",
    bisShort: "BiS",
    bsShort: "BS",
    cbeShort: "CBE",
    ceShort: "CE",
    chShort: "CH",
    csShort: "CS",
    eeShort: "EE",
    idShort: "ID",
    ieShort: "IE",
    masShort: "MAS",
    meShort: "ME",
    nqeShort: "NQE",
    btmShort: "BTM",
    msShort: "MS",
    phShort: "PH",
    tsShort: "TS",
    ssShort: "SS",
    bcsShort: "BCS",
    aicShort: "AIC",
    etcShort: "ETC",
}
